
import LayoutContent from '../../components/layouts/content2';
import React, { useEffect, useState } from 'react';

import { getImage, getData } from '../../helpers/indexedDbHelper';
import {useTranslation} from 'react-i18next';
import { useRefresh } from '../../hooks/useRefresh';
import translate from '../../helpers/translate';
import translateMenu from '../../helpers/translateMenu';
import ListProducts from './ListProducts';
import SpecialsScreen from './specials';
import HappyHourScreen from './happyHour';
import CategoriesScreen from './categories';


function Index({dishMenu, setShowDetailProduct, setShowListProduct2}) { 

      const {i18n} = useTranslation();
      const langEng = i18n.language === 'en' ?? false;
  
      const { dish, alldish } = dishMenu;
  
      const [dataDish, setDataDish] = useState(dish);
      const [dataDesserts, setDataDesserts] = useState(false);
    const [dataDrinks, setDataDrinks] = useState(false);
     const [showHappy, setShowHappy] = useState(false);
    
    const [isImageLoading, setIsImageLoading] = useState(true); 
    const [isImageLoadingOne, setIsImageLoadingOne] = useState(true); 
    const [isImageLoadingTwo, setIsImageLoadingTwo] = useState(true); 
    const [showCategories, setshowCategories] = useState(false);
    
    const [image, setImage] = useState(false);
     const [imageOne, setImageOne] = useState(false);
        const [imageTwo, setImageTwo] = useState(false);
    
        const [showListProduct, setShowListProduct] = useState(false);
        const [dishs, setdishs] = useState(false);
  
      const {change} = useRefresh();
        const [menus, setMenus] = useState([]);
    
    const [flavors, setFlavors] = useState(dish.flavors);
    
    const [showSpecials, setShowSpecials] = useState(false);
    
    
      useEffect(() => {
          getData('menu').then((items) => {
              const data = items.value.data;
              setMenus(data);
          });
      }, [change]);
      
      
    useEffect(() => {
        setIsImageLoading(true);
        setIsImageLoadingOne(true);
        setIsImageLoadingTwo(true);
          fetchImage(`menu-image-h-${dataDish.id}`).then((url) => {
              if (url) {
                  setImage(url);
                  setIsImageLoading(false); 
              }
          });

           fetchImage(`menu-image-one-${dataDish.id}`).then(async (url) => {
               if (url) {
                   const isValid = await isValidImage(url);
                   if (isValid) {
                       setImageOne(url);
                        setIsImageLoadingOne(false);
                    }
                }    
            }); 

        fetchImage(`menu-image-two-${dataDish.id}`).then(async (url) => {
            if (url) {
                const isValid = await isValidImage(url);
                if (isValid) {
                    setImageTwo(url);
                     setIsImageLoadingTwo(false);
                }
                
            }
        });
  
      }, [dataDish]);
      
    
        useEffect(() => {
        setFlavors(dataDish.flavors)
    }, [dataDish])
    
    const isValidImage =(url) => {
            return new Promise((resolve) => {
                const img = new Image();
                img.onload = () => resolve(true); // La imagen se cargó correctamente
                img.onerror = () => resolve(false); // La imagen está rota o no se puede cargar
                img.src = url; // Inicia la carga de la imagen
            });
        }
  
       useEffect(() => {
          menus.map((item) => {
              if (item.id === 442) {
              setDataDesserts(item);
              }
              
              if (item.id === 429) {
                  setDataDrinks(item)
              }
         
          });
      }, [menus]);
  
  
      const fetchImage = async (id) => {
          const imageBlob = await getImage(id);
          if (imageBlob) {
              const imageURL = URL.createObjectURL(imageBlob.data.blob);
              return imageURL;
          }
          return null;
      };
  
  
      const navDish = (position) => {
          const menuIndex = alldish.findIndex(item => item === dataDish);
  
          let newIndex;
          if (position === 1) {
          newIndex = (menuIndex + 1) % alldish.length;
          } else if (position === -1) {
          newIndex = (menuIndex - 1 + alldish.length) % alldish.length;
          } else {
          return;
          }
          const newDish = alldish[newIndex];
          setDataDish(newDish);
      };
    
    return (
        <div style={{position: 'absolute', top: 0, left: 0, width: '100%', height: '100%', zIndex: 999}}>
            <LayoutContent  goCategories={setshowCategories} showLogo={true}  showImageTop={false}  setShowListProduct={setShowDetailProduct} setShowSpecials={setShowSpecials} goHome={setShowListProduct2}>
                
                <div
                    style={ {
                        position: 'absolute',
                        zIndex: 999,
                        top: '27%',
                        left: 20,
                        }}>
                    <div
                        style={
                        {
                            width: 45,
                            height: 45,
                            backgroundColor: '#000',
                            borderRadius: 100,
                            borderWidth: 3,
                            borderColor: 'white',
                        }
                        }
                        onClick={() => [
                        navDish(-1),
                      
                        ]}>
                        <img
                            onContextMenu={(e) => e.preventDefault()}
                            style={{width: 30, height: 30, objectFit: 'contain',  pointerEvents: 'none', marginTop: 5}}
                            src={require('./assets/right.png')}
                        />
                    </div>
                </div>

                 <div
                    style={ {
                        position: 'absolute',
                        zIndex: 999,
                        top: '27%',
                        right: 20,
                        }}>
                    <div
                        style={
                        {
                            width: 45,
                            height: 45,
                            backgroundColor: '#000',
                            borderRadius: 100,
                            borderWidth: 3,
                            borderColor: 'white',
                        }
                        }
                        onClick={() => [
                        navDish(1),
                      
                        ]}>
                        <img
                            onContextMenu={(e) => e.preventDefault()}
                            style={{width: 30, height: 30, objectFit: 'contain',  pointerEvents: 'none', marginTop: 5}}
                            src={require('./assets/left.png')}
                        />
                    </div>
                </div>
                


                <div style={{overflow:'scroll',  opacity: isImageLoading ? 0 : 1, 
                                    transition: "opacity 0.5s ease-in-out",paddingInline: 40}}>
                    <div style={{ padding: '10px 20px' }}>
                        <div style={{ minHeight: 330}}>
                            <img
                                onContextMenu={(e) => e.preventDefault()}
                                src={image}
                                alt="Dynamic content"
                                style={{
                                    width: "100%",
                                    height: 370,
                                    objectFit: "cover",
                                    borderRadius: 20,
                                     pointerEvents: 'none',
                                    opacity: isImageLoading ? 0 : 1, 
                                    transition: "opacity 0.5s ease-in-out", 
                                }}
                                onLoad={() => setIsImageLoading(false)} 
                                />
                       </div>

                        <div style={{
                            marginTop: 5,
                            padding: 15,
                         
                            borderRadius: 20,
                            
                        }}>
                                <div style={{
                                    flexDirection: 'row',
                                    justifyContent: 'space-between',
                                    alignItems: 'center',
                                    display: 'flex',
                                    
                                    
                                }}>

                                    <div style={{
                                        
                                        display: 'flex',
                                        flexDirection: 'row',
                                        alignItems: 'center',
                                        justifyContent: 'space-between',
                                        width: '80%'
                                    }}>
                                        <p className='shor-text-one' style={{fontSize: 32, color: 'white', fontWeight: '900',textAlign: 'left'}}>
                                        {langEng ? dataDish.name : translate(i18n.language, dataDish.language, dataDish.name)}
                                        </p>
                                    </div>

                                {flavors.length === 0 && dataDish.price > 0 && (
                                    <div style={{
                                        display: 'flex',
                                        flexDirection: 'row',
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                    margin: '0px 10px',
                                    gap: 10,
                                    border: '1px solid black',
                                        width: 120
                                    ,
                                        background: 'white',
                                    textAlign: 'center',
                                    alignItems: "center",
                                    borderRadius: 100,
                                        height: 50,
                                    }}>
                                        <p
                                            style={{ fontSize: 24, color: '#000', fontWeight: 'bold', textAlign: 'center',fontFamily: "Arial", }}>
                                            {flavors.length === 0 && (
                                                <>
                                                    {dataDish.price > 0
                                                        ? `$ ${dataDish.label_price ?? ''} ${
                                                            dataDish.price.toFixed(2)
                                                        }`
                                                        : ''}
                                                </>
                                            )}
                                        </p>

                                   
                                    </div>
                                )}
                                    
                                </div>
                                
                                <div>
                                    <p
                                       
                                
                                    style={{fontSize: 18, textAlign:'left', color: 'white', fontWeight: '700'}}>
                                    {langEng ? 
                                                    `${dataDish.regular_decription.replace(/\\n/g,'\n')}`
                                                : 
                                                `${translateMenu(
                                                    i18n.language, 
                                                    dataDish.language, 
                                                    dataDish.regular_decription, 
                                                    'regular_decription'
                                                )}`
                                        }
                                        
                                        
                                    </p>
                            </div>


                            {
                                dataDish.id == 3781 && 
                                    <div style={{textAlign: 'left'}}>
                                        <h4 style={{ color: '#FEBA29', margin: "4px 0px", fontSize: 18, textTransform: 'uppercase' }}>choose your favorite Tequila</h4>
                                        <p style={{ color: '#fff', fontSize: 18,  }}>Casamigos, Patron, 1800, Herradura, Don Julio</p>
                                    </div>
                            }
                            

                        {flavors.length > 0 && (
                        <div
                                    style={{
                                display: 'flex',
                            flexDirection: 'row',
                            justifyContent: 'flex-start',
                            flexWrap: 'wrap',
                            marginTop: 10,
                            }}>
                            {flavors.map((item, key) => {
                            return (
                                <div
                                key={key}
                                style={{
                                    backgroundColor: 'black',
                                    width: '29%',
                                    marginHorizontal: 1,
                                    margin: '1px 1px',
                                    borderRadius: 10,
                                    paddingBlock: 20,
                                    paddingInline: 0,
                                    display: 'flex',
                                    flexDirection: 'row',
                                    justifyContent: 'space-between',
                                    alignItems: 'center',
                                    position: 'relative',
                                    
                                }}>
                                    <p
                                        className='shor-text'
                                        style={{
                                            textAlign: 'center',
                                            position: 'absolute',
                                            color: 'white',
                                            fontSize: 14,
                                            left: 10,
                                            width:'70%'
                                        }}>
                                            {item.name}
                                    </p>

                                <p
                                    className='shor-text'
                                    style={{
                                        color: 'white',
                                        position: 'absolute',
                                        right: 10,
                                        
                                    }}>
                                    $ {item.price}
                                    </p>
                                </div>
                            );
                            })}
                        </div>
                        )}
                                
                        </div>
                        
                    </div>

                    {dataDish.id == 3781 &&
                        <div>
                             <img
                                            src={require('./assets/sangria.png')}
                                            resizeMode={'cover'}
                                            style={{
                                                width: 480,
                                                height: 190,
                                                borderRadius: 14,
                                            
                                                objectFit: 'contain',
                                                boderRadius: 20,
                                            }}
                                        />
                        </div>
                    }

                    {dataDish.id != 3781 && 
                     <div
                                    style={{
                                        display: 'flex',
                                        flexDirection: 'row',
                                        justifyContent: 'space-between',
                                        alignItems: 'center',
                                    paddingInline: 20,
                                 
                                    }}>
                                    <div onClick={() => [setShowListProduct(true), setdishs(dataDesserts)]} style={{
                                                        borderRadius: 10,
                                                       
                                                        display: 'flex',
                                                        justifyContent: "center",
                                                        elevation: 1,position: 'relative'}} >
                                <img
                                    onContextMenu={(e) => e.preventDefault()}
                                            src={require('./assets/desserts.png')}
                                            resizeMode={'cover'}
                                            style={{
                                                width: 280,
                                                height: 250,
                                                borderRadius: 14,
                                                 pointerEvents: 'none',
                                                objectFit: 'contain',
                                                boderRadius: 20,
                                            }}
                                        />
                                        
                                    </div>

                                    <div onClick={() => [setShowHappy(true)]} style={{
                                                        borderRadius: 10,
                                                      
                                                        display: 'flex',
                                                        justifyContent: "center",
                                                        elevation: 1,position: 'relative'}}>
                                <img
                                    onContextMenu={(e) => e.preventDefault()}
                                            src={require('./assets/DSC08527.png')}
                                            resizeMode={'cover'}
                                        style={{
                                            width: 280,
                                                height: 250,
                                            borderRadius: 14,
                                             pointerEvents: 'none',
                                            objectFit: 'contain',
                                            boderRadius: 20,
                                        }}
                                    />
                                   
                                    </div>
                    </div>
                    }
                               
                   
                </div>
            </LayoutContent>
             {showListProduct && <ListProducts
                dishs={dishs}
                setShowListProduct={setShowListProduct}
                goHome={setShowListProduct2}
            />}

             {showCategories && <CategoriesScreen setshowCategories={setshowCategories} />}

            {showSpecials && <SpecialsScreen setShowListProduct={setShowSpecials} setShowHappy={setShowListProduct2} />}
            
             {showHappy && <HappyHourScreen setShowHappy={setShowHappy} />}
        </div>
    );
}
export default Index;